import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue'),  // 懒加载组件，提高运行性能
    },
    {
      path: '/menu',
      name: 'menu',
      // redirect: '/about',
      component: Layout,  // 主模版组件 
      meta: {  // 渲染右侧区域的面包屑标题
        title: '公共组件',
        levelList: []
      },
      children: [
        {
          path: '/total',
          name: 'baseTotal',
          component: () => import('../views/Total.vue'),  // 懒加载组件，提高运行性能
        },
        {
          path: '/about',
          name: 'baseAbout',
          component: () => import('../views/About.vue'),  // 懒加载组件，提高运行性能
        },
        {
          path: '/new',
          name: 'baseNew',
          component: () => import('../views/New.vue'),  // 懒加载组件，提高运行性能
        },
        {
          path: '/Tree',
          name: 'baseTree',
          component: () => import('../views/Tree.vue'),  // 懒加载组件，提高运行性能
        },
        {
          path: '/Topic',
          name: 'baseTopic',
          component: () => import('../views/Topic.vue'),  // 懒加载组件，提高运行性能
        },
        {
          path: '/Topicforum',
          name: 'baseTopicforum',
          component: () => import('../views/Topicforum.vue'),  // 懒加载组件，提高运行性能
        },
        {
          path: '/CampusPass',
          name: 'baseCampusPass',
          component: () => import('../views/CampusPass.vue'),  // 懒加载组件，提高运行性能
        },
        {
          path: '/Found',
          name: 'baseFound',
          component: () => import('../views/Found.vue'),  // 懒加载组件，提高运行性能
        },
        {
          path: '/Rotationmap',
          name: 'baseRotationmap',
          component: () => import('../views/Rotationmap.vue'),  // 懒加载组件，提高运行性能
        }
        ,
        {
          path: '/RotationmapList',
          name: 'baseRotationmapList',
          component: () => import('../views/RotationmapList.vue'),  // 懒加载组件，提高运行性能
        },
        {
          path: '/NewMessage',
          name: 'NewMessage',
          component: () => import('../views/NewMessage.vue'),  // 懒加载组件，提高运行性能
        }
        ,
        {
          path: '/Users',
          name: 'Users',
          component: () => import('../views/Users.vue'),  // 懒加载组件，提高运行性能
        }
        ,
        {
          path: '/Label',
          name: 'Label',
          component: () => import('../views/Label.vue'),  // 懒加载组件，提高运行性能
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js